import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";


// 모달 버튼


export default function ModalButtonPath({setShowModal , submitClick,path}){
    
    return (
        <ModalButtonInner>
            <ModalBtn 
                onClick={()=>{setShowModal(false)}} 
                style={{borderRight:"calc(100vw*(1/375)) solid #c6c6c6"}}>
            {"취소"}
            </ModalBtn>
            <Link component={ModalBtn} to={path} 
                onClick={()=>{submitClick ? submitClick() : setShowModal(false)}} 
               >
            {"확인"}
            </Link>
        </ModalButtonInner>
    )
}




const ModalButtonInner = styled.div`
    width: 100%;
    height: calc(100vw*(44/375));
    border-top: calc(100vw*(1/375)) solid #c6c6c6;
`
const ModalBtn = styled.a`
    width:50%;
    height:100%;
    font-size: calc(100vw*(16/375));
    font-weight: bold;
    line-height:calc(100vw*(42/375));
    text-align: center;
    color: #008aff;
`